import { SelectProps, Spin } from 'antd';
import Select from 'antd/lib/select';
import React, { FC, ReactNode, Ref } from 'react';
import { NegativeTriangle, PositiveTriangle } from 'assets/svg';
import { colorConstants } from 'config/colorConstants';
import Loader from '../Loader';
import ErrorBox from '../ErrorBox/ErrorBox';

type OfferDropdownItem = {
    offer: string;
    uplift?: { value: string | number; isPositive: boolean };
    roi?: { value: string | number; isPositive: boolean };
};

interface Props extends SelectProps {
    data: OfferDropdownItem[];
}
const { Option } = Select;

const OfferDropdown: FC<Props> = ({ data, ...restProps }) => {
    const { loading } = restProps;
    return (
        <Select
            {...restProps}
            notFoundContent={
                loading ? (
                    <div className="p-3">
                        <Loader />
                    </div>
                ) : (
                    <ErrorBox msg="No Data" />
                )
            }
        >
            {data?.map((item) => {
                return (
                    <Option item={item} value={item?.offer} key={item?.offer}>
                        <div className=" font-xs">{item.offer}</div>
                        <div className="flex gap-4 mt-1">
                            {item?.uplift && (
                                <div className="flex gap-1 items-center">
                                    <span className="text-fontGreyAlt font-xxs">Uplift:</span>
                                    <span className="ml-2">
                                        {item?.uplift?.isPositive ? <PositiveTriangle /> : <NegativeTriangle />}
                                    </span>
                                    <span
                                        style={{
                                            color: item?.uplift?.isPositive
                                                ? colorConstants.limeGreen
                                                : colorConstants.red,
                                        }}
                                    >
                                        {item.uplift.value}
                                    </span>
                                </div>
                            )}
                            {item?.roi && (
                                <div className="flex gap-1 items-center">
                                    <span className="text-fontGreyAlt font-xxs">ROI:</span>
                                    <span className="ml-2">
                                        {item?.roi?.isPositive ? <PositiveTriangle /> : <NegativeTriangle />}{' '}
                                    </span>
                                    <span
                                        style={{
                                            color: item?.roi?.isPositive
                                                ? colorConstants.limeGreen
                                                : colorConstants.red,
                                        }}
                                    >
                                        {item.roi.value}
                                    </span>
                                </div>
                            )}
                        </div>
                    </Option>
                );
            })}
        </Select>
    );
};

export default OfferDropdown;
